var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('embed',{staticStyle:{"width":"100%","height":"calc(100vh - 76px)","margin-top":"76px","display":"block","overflow":"auto"},attrs:{"src":"https://tpsql.transplus.ca/REPORTFILES/Pages/ReportViewer.aspx?%2fWAREHOUSE%2fWHSE_SPACE_V3&rs:Command=Render"}})])
}]

export { render, staticRenderFns }